module.exports = __webpack_public_path__ + "static/phone-79f811c67b9db978d69a3ed8770f77d6.png";